// src/components/admin/Button.jsx
const Button = ({ variant = "primary", iconLeft, className, children, ...rest }) => {
  const base =
    "rounded-2xl px-4 py-2 text-sm font-medium flex items-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed";
  const theme =
    {
      primary: "bg-indigo-600 text-white hover:bg-indigo-700",
      ghost: "bg-transparent hover:bg-gray-100 text-gray-800",
      danger: "bg-rose-600 text-white hover:bg-rose-700",
      outline: "border border-gray-300 hover:bg-gray-50",
      subtle: "bg-gray-100 text-gray-900 hover:bg-gray-200",
      solid: "bg-red-600 text-white hover:bg-red-700",
    }[variant] || "";
  return (
    <button className={`${base} ${theme} ${className || ""}`} {...rest}>
      {iconLeft}
      {children}
    </button>
  );
};
export default Button;
